var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2E048894-DEBE-40DA-B77B-6E3EBDEAEF99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Dashboard---Digital",
    transform: "translate(-24.000000, -134.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-home-icon",
    transform: "translate(24.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.54394124,0.160936186 L15.5439412,4.70019371 C15.8283358,4.88461374 16,5.2005833 16,5.53962734 L16,14.9996302 C16,15.5521192 15.5522847,16 15,16 L1,16 C0.44771525,16 0,15.5521192 0,14.9996302 L0,5.53962734 C0,5.2005833 0.171664184,4.88461374 0.45605876,4.70019371 L7.45605876,0.160936186 C7.78696554,-0.0536453954 8.21303446,-0.0536453954 8.54394124,0.160936186 Z M8,1.00036982 L1,5.53962734 L1,14.9996302 L15,14.9996302 L15,5.53962734 L8,1.00036982 Z M9.5,5.49611692 C10.0522847,5.49611692 10.5,5.94399775 10.5,6.49648674 L10.5,9.49759619 C10.5,10.0500852 10.0522847,10.497966 9.5,10.497966 L6.5,10.497966 C5.94771525,10.497966 5.5,10.0500852 5.5,9.49759619 L5.5,6.49648674 C5.5,5.94399775 5.94771525,5.49611692 6.5,5.49611692 L9.5,5.49611692 Z M9.5,6.49648674 L6.5,6.49648674 L6.5,9.49759619 L9.5,9.49759619 L9.5,6.49648674 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDigital);
export default __webpack_public_path__ + "static/media/home-digital.a53b00ab8c7ba86f6b05cead9c2d8b76.svg";
export { ForwardRef as ReactComponent };